import React, {
	useState,
	useEffect,
	useContext,
	Fragment,
	useRef
} from "react";
import {
	Alert,
	ButtonGroup,
	Divider,
	FormControlLabel,
	Grid,
	SwipeableDrawer,
	Switch,
	TextField,
	ToggleButton,
	ToggleButtonGroup,
	Button,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	SelectChangeEvent,
	Accordion,
	AccordionSummary,
	AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEnvContext } from "contexts/EnvProvider";
import { FeaturesFlags } from "helpers";
import { WebStoreContext } from "../../contexts/WebStoreProvider";
import { DebugWebStoreContext } from "../contexts/DebugWebStoreProvider";
import SetLoyaltyPointsDialog from "./SetLoyaltyPointsDialog";
import SetDailyLoginSeriesDialog from "./SetDailyLoginSeriesDialog";
import SetAuthTokenTtlDialog from "./SetAuthTokenTtlDialog";
import { GoogleAnalyticsContext } from "../../contexts/GoogleAnalyticsProvider";
import { useAppDispatch, useAppSelector } from "hooks";
import {
	//clearGiftGaloreTracker,
	clearDailyLoginTracker,
	clearUserDipActions,
	clearUserDipRequisitions,
	clearUserStickyDip,
	clearWaterfallAllTracker,
	clearWaterfallCurrentTracker,
	debugState,
	getAllDIPs,
	getCurrentSegments,
	getCurrentUserSegments,
	isDebugEnabled,
	onDIPtrigger,
	//onSeenRewardedPopUp,
	selectDipState,
	setShowDebugLabels,
	clearSpecificStickyDip,
	selectStickyDIPState,
	postUserTrackerValue,
	onOpenPopUp,
	getDIPs
} from "redux/slices";
import {
	clearAllTrackers,
	clearPurchaseTrackers
} from "redux/slices/web-store/thunks";
import ClubFreeGiftTools from "./ClubFreeGiftTools";
import ConfirmDialog from "./ConfirmDialog";
import ResultConfirmationDialog from "./ResultConfirmationDialog";
import SegmentationDialog from "./SegmentationDialog";
import SetClubGiftsGalorePurchaseDialog from "./SetClubGiftsGalorePurchaseDialog";
//import { CGG_POP_UP_REWARDED } from "pages/ClubShop/ClubEventSection/useInitialActions";
import SetEndlessOfferPurchaseDialog from "./SetEndlessOfferPurchaseDialog";
import {
	featureTrackerAPI,
	useClearDebugExperimentsMutation,
	useDeleteFeatureTrackerMutation,
	useDeleteMetadataMutation,
	useGetDebugExperimentsQuery
} from "redux/apis";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import GetLocalTimeZones from "./SetLocalTime";
import ExperimentsDialog from "./ExperimentsDialog";
import { PopUpVariant } from "interfaces";
import { useSimulatePurchaseMutation } from "redux/apis/clubGiftsGalore";
import { ClubGiftsGaloreResponse } from "interfaces/club-gifts-galore-v2";
import { FeatureType } from "interfaces/feature-tracker";
import { NetworkLogs } from "./NetworkLogs";
import RebateOfferTools from "./RebateOfferTools";
import PopupTools from "./PopupTools";
import { getPlatform } from "utils/platform";
import { PoisBountyTools } from "./PoisBountyTools";
import PWATools from "./PWATools";
import ClearAppPurchaseData from "./ClearAppPurchaseData";
import UserIdBox from "./UserTools/UserIdBox";
import TimeTools from "./TimeTools";
/*
TODO: aaron: fix this error (only happening for me), for now casting as any

const SwipeableDrawer: React.JSXElementConstructor<SwipeableDrawerProps>
'SwipeableDrawer' cannot be used as a JSX component.
	Its element type 'Component<any, any, any> | ReactElement<any, any> | null' is not a valid JSX element.
		Type 'Component<any, any, any>' is not assignable to type 'Element | ElementClass | null'.
			Type 'Component<any, any, any>' is not assignable to type 'ElementClass'.
				The types returned by 'render()' are incompatible between these types.
					Type 'React.ReactNode' is not assignable to type 'import("/Users/aostrowsky/Code/GsnGames/gsnsocial/tripeaks-web/frontend/node_modules/@types/react-transition-group/node_modules/@types/react/index").ReactNode'.
						Type '{}' is not assignable to type 'ReactNode'.

*/
const MySwipeableDrawer = SwipeableDrawer;

const DebugConsole = () => {
	const dispatch = useAppDispatch();
	const { debug, data } = useAppSelector(selectDipState);
	const { isFeatureFlagEnabled } = useEnvContext();
	const isDIPsEnabled = isFeatureFlagEnabled(FeaturesFlags.DIPS);
	const dips = debug.data?.dips ?? data.dips;
	const timerRef = useRef<number>();
	const { debugEnabled } = useAppSelector(debugState);
	const { stickyDIPsDisplayed } = useAppSelector(selectStickyDIPState);
	const {
		userTracker,
		syncUserTracker,
		serverNamespace,
		namespaceOverride,
		setNamespaceOverride,
		setDryRunOverride
		//logout
	} = useContext(WebStoreContext);
	const {
		clearInboxMessages,
		clearFirstLoginReward,
		clearUser,
		enableDebugAccess,
		handleRefresh,
		authToken,
		setAuthTokenTtl
	} = useContext(DebugWebStoreContext);
	const { data: abData } = useGetDebugExperimentsQuery("", {
		skip: !authToken?.value
	});
	const { adsPersonalization, enableAdsPersonalization } = useContext(
		GoogleAnalyticsContext
	);
	const platform = getPlatform();
	const [open, setOpen] = useState(false);
	const [dip, setDip] = useState<string>("");
	const [metadata, setMetadata] = useState<string>("");
	const [popup, setPopup] = useState<PopUpVariant | "">("");
	const [tuid, setTuid] = useState<string>(userTracker?.id || "");
	const [confirmResultDialog, setConfirmResultDialog] = useState(false);
	const [confirmResultTitle, setConfirmResultTitle] = useState("");
	const [alternateNamespace, setAlternateNamespace] = useState("");
	const [deleteFeatureTracker] = useDeleteFeatureTrackerMutation();
	const [deleteMetadata] = useDeleteMetadataMutation();
	const [clearExperiments] = useClearDebugExperimentsMutation();
	const [simulatePurchase] = useSimulatePurchaseMutation();
	const [filterNetworkFieldFocused, setFilterNetworkFieldFocused] =
		useState(false);
	const showDebugLabels = useSelector(
		(state: RootState) => state.debug.showDebugLabels
	);
	const { data: cggv2 }: { data?: ClubGiftsGaloreResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: FeatureType.CLUB_GIFT_BONUS_V2,
			isAuthenticated: !!authToken?.value
		});

	useEffect(() => {
		if (serverNamespace === "develop") {
			setAlternateNamespace("dev-release");
		} else if (serverNamespace === "dev-release") {
			setAlternateNamespace("develop");
		} else if (serverNamespace === "live") {
			setAlternateNamespace("prod-release");
		} else if (serverNamespace === "prod-release") {
			setAlternateNamespace("live");
		}
	}, [serverNamespace]);

	useEffect(() => {
		if (authToken) {
			dispatch(isDebugEnabled());
		}
	}, [authToken]);

	const handleClose = () => {
		setOpen(false);
	};

	const handleDipSelect = (event: SelectChangeEvent) => {
		setDip(event.target.value as string);
	};

	const handleMetadataSelect = (event: SelectChangeEvent) => {
		setMetadata(event.target.value as string);
	};

	const handlePopupTrigger = (event: SelectChangeEvent) => {
		setPopup(event.target.value as PopUpVariant);
	};

	const handleTuid = (event: SelectChangeEvent) => {
		setTuid(event.target.value as string);
	};

	const onClickEnableDebugActions = async () => {
		await enableDebugAccess();
		reloadPage();
	};

	const onClickClearInboxMessages = async () => {
		const success = await clearInboxMessages();
		showSuccessDialog(success, "Clear Inbox Messages");
	};

	const onClickClearFirstLogin = async () => {
		const success = await clearFirstLoginReward();
		showSuccessDialog(success, "Clear First Login");
	};

	const onClickClearUser = async () => {
		const success = await clearUser();
		//logout();
		localStorage.clear();
		showSuccessDialog(success, "Clear User");
		reloadPage();
	};
	const onClickShowHideDebugLabels = async () => {
		dispatch(setShowDebugLabels(!showDebugLabels));
	};
	const onClearAllTrackers = async () => {
		dispatch(clearAllTrackers());
		showSuccessDialog(true, "All trackers cleared");
	};

	const onClearPurchaseTrackers = async () => {
		dispatch(clearPurchaseTrackers());
		showSuccessDialog(true, "Purchase trackers cleared");
	};
	const onClickSetAuthToken = async (authTtlValue: number) => {
		const success = await setAuthTokenTtl(authTtlValue);
		showSuccessDialog(success, "Set Auth Token");
	};

	const onClearUserDipActions = (): void => {
		const preventDoubleGetDips = false;
		dispatch(clearUserDipActions({ preventDoubleGetDips }));
		showSuccessDialog(true, "DIP actions cleared");
	};

	// const onClearGiftsGaloreTracker = (): void => {
	// 	dispatch(clearGiftGaloreTracker());
	// 	localStorage.removeItem(CGG_POP_UP_REWARDED);
	// 	showSuccessDialog(true, "Club Gifts Galore tracker cleared");
	// };

	const onClearGiftsGaloreV2Tracker = async () => {
		await deleteFeatureTracker({ FeatureType: "club-gift-bonus-v2" }).unwrap();
		showSuccessDialog(true, "Club Gifts Galore tracker cleared");
	};

	const onSimulatePurchaseGiftsGalore = async () => {
		await simulatePurchase({
			body: { userId: tuid }
		}).unwrap();
		showSuccessDialog(true, "Club Gifts Galore v2 purchase success");
	};

	const onClearEndlessOffersTracker = async () => {
		//dispatch(clearEndlessOfferTracker());
		await deleteFeatureTracker({ FeatureType: "endless-offer" }).unwrap();
		showSuccessDialog(true, "Endless Offers tracker cleared");
	};

	// const onClearGiftsGaloreViewCount = (): void => {
	// 	localStorage.removeItem(CGG_POP_UP_REWARDED);
	// 	showSuccessDialog(true, "Club Gifts Galore view count cleared");
	// };

	// const onClearGiftsGaloreSeenReward = (): void => {
	// 	dispatch(onSeenRewardedPopUp(false));
	// 	showSuccessDialog(true, "Club Gifts Galore seen reward set to false");
	// };

	const onClearUserDipRequisitions = (): void => {
		const preventDoubleGetDips = false;
		dispatch(clearUserDipRequisitions({ preventDoubleGetDips }));
		showSuccessDialog(true, "DIP requisitions cleared");
	};

	const onClearUserStickyDip = (): void => {
		dispatch(clearUserStickyDip());
		showSuccessDialog(true, "Sticky DIPs cleared");
	};

	const onClearSpecificStickyDip = async () => {
		await dispatch(clearSpecificStickyDip(dip));
		showSuccessDialog(true, "Sticky DIP cleared");
		setDip("");
	};

	const onClearAll = async () => {
		const preventDoubleGetDips = true;
		dispatch(clearUserStickyDip());
		dispatch(clearUserDipActions({ preventDoubleGetDips }));
		dispatch(clearUserDipRequisitions({ preventDoubleGetDips }));
		dispatch(
			postUserTrackerValue({
				key: "lastSeenLimitedDealSectionV2",
				value: ""
			})
		);
		dispatch(getDIPs());
		showSuccessDialog(true, "All cleared");
	};

	const onClearWaterfallTracker = (): void => {
		dispatch(clearWaterfallCurrentTracker());
		showSuccessDialog(true, "All User trackers cleared");
	};

	const onClearDailyLoginStreakTracker = (): void => {
		dispatch(clearDailyLoginTracker());
		showSuccessDialog(true, "Daily Login Streak tracker cleared");
	};

	const onClearWaterfallTrackers = (): void => {
		dispatch(clearWaterfallAllTracker());
		showSuccessDialog(true, "All User trackers cleared");
	};

	const onClearDripOfferTracker = async () => {
		await deleteFeatureTracker({
			FeatureType: FeatureType.DRIP_OFFER
		}).unwrap();
		showSuccessDialog(true, "Drip Offer tracker cleared");
	};

	const onClearABExperiments = async () => {
		await clearExperiments("").unwrap();
		showSuccessDialog(true, "A/B experiments cleared");
	};

	const onClearMetadata = async () => {
		await deleteMetadata({ key: metadata }).unwrap();
		setMetadata("");
		showSuccessDialog(true, "Metadata cleared");
		syncUserTracker();
	};

	const showSuccessDialog = async (success: boolean, title: string) => {
		if (success) {
			setConfirmResultTitle(title);
			setConfirmResultDialog(true);
		}
	};

	const toggleDrawer = (open: boolean) => () => {
		setOpen(open);
	};

	const onClickOpenAdminTool = () => {
		let adminUri;
		if (serverNamespace === "develop" || serverNamespace === "dev-release") {
			adminUri = "https://ps.tripeaksapp-dev.com";
		} else {
			adminUri = "https://ps.tripeaksapp.com";
		}
		window.open(
			`${adminUri}/admin/?paramType=uuid&paramValue=${userTracker?.id}#tab=player`
		);
	};

	const onClickClearStorage = () => {
		localStorage.clear();
		sessionStorage.clear();
		reloadPage();
	};

	const reloadPage = () => {
		clearTimeout(timerRef.current);
		timerRef.current = window.setTimeout(() => {
			window.location.reload();
		}, 3000);
	};

	useEffect(() => {
		// TODO: sync onClose - verify all good compared to sync onOpen
		if (!open && authToken?.value) {
			const onClose = async () => {
				await syncUserTracker();
			};
			onClose();
		}
		/* eslint-disable-next-line */
		const handleKeyDown = (event: any) => {
			if (
				!filterNetworkFieldFocused &&
				(event.key === "D" || event.key === "d" || event.keyCode === 27)
			) {
				setOpen(!open);
			}
		};

		document.addEventListener("keydown", handleKeyDown);
		return function cleanup() {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, [open, filterNetworkFieldFocused]);

	const handleNamespaceToggle = (
		event: React.MouseEvent<HTMLElement>,
		newAlignment: string | null
	) => {
		if (newAlignment === serverNamespace) {
			setNamespaceOverride(null);
		} else {
			setNamespaceOverride(alternateNamespace);
		}
		handleRefresh();
		reloadPage();
	};

	/* eslint-disable */
	const handleDryRunToggle = (
		event: React.MouseEvent<HTMLElement>,
		value: any
	) => {
		setDryRunOverride(value);
	};
	/* eslint-enable */

	const handleAdsPersonalizationChange = () => {
		enableAdsPersonalization(!adsPersonalization, userTracker);
	};

	useEffect(() => {
		if (!isDIPsEnabled || !userTracker) {
			return;
		}
		dispatch(getCurrentSegments());
		dispatch(getCurrentUserSegments());
	}, [userTracker, isDIPsEnabled]);

	return (
		<>
			{!open && (
				<div>
					<Button
						variant="contained"
						size="small"
						onClick={() => setOpen(true)}
						sx={{
							position: "fixed",
							top: "40%",
							right: 0,
							zIndex: 1300,
							"@supports (height: 1svh)": {
								top: "40svh"
							},
							borderTopLeftRadius: 0,
							borderBottomLeftRadius: 8,
							borderTopRightRadius: 0,
							borderBottomRightRadius: 8,
							padding: "4px 6px",
							minWidth: "26px",
							transform: "rotate(90deg)",
							transformOrigin: "top right",
							whiteSpace: "nowrap",
							fontSize: "10px"
						}}
					>
						Debug
					</Button>
				</div>
			)}
			<MySwipeableDrawer
				id="debug-console"
				anchor={"right"}
				open={open}
				variant="temporary"
				onClose={toggleDrawer(false)}
				onOpen={toggleDrawer(true)}
				disableSwipeToOpen={true}
				hideBackdrop={true}
				sx={{
					"& > :not(style)": {
						p: 1,
						boxSizing: "border-box",
						width: "35ch",
						maxWidth: "100dvw",
						marginTop: "50px"
					}
				}}
			>
				<br />
				<div>
					<ButtonGroup>
						<Button color="success" variant="contained" onClick={handleRefresh}>
							Refresh
						</Button>
						<Button color="error" variant="contained" onClick={handleClose}>
							X
						</Button>
					</ButtonGroup>
				</div>

				{debugEnabled.success && !debugEnabled.enabled && (
					<>
						<Alert style={{ margin: "1rem 0" }} severity="error">
							User is not enabled for debug in TriPeaks. Click on Open Admin
							Tool to enable or click here.
						</Alert>
						<ButtonGroup>
							<Button onClick={onClickEnableDebugActions}>Enable</Button>
						</ButtonGroup>
					</>
				)}

				<h3 style={{ marginBottom: 0 }}>
					{process.env.REACT_APP_WEBSTORE_RELEASE_VERSION}
				</h3>

				{serverNamespace && (
					<>
						<h1 style={{ marginTop: 0 }}>Environment</h1>
						<div>
							<TextField
								disabled
								label="Server Backend"
								value={serverNamespace.toUpperCase()}
							/>
						</div>
						<br />
						<div>
							<Grid container>
								<Grid item>LiveOps Namespace</Grid>
								<Grid item>
									<ToggleButtonGroup
										value={
											namespaceOverride ? namespaceOverride : serverNamespace
										}
										exclusive
										onChange={handleNamespaceToggle}
										aria-label="text alignment"
									>
										<ToggleButton
											value={serverNamespace}
											aria-label="left aligned"
											color="success"
										>
											{serverNamespace}
										</ToggleButton>
										<ToggleButton
											value={alternateNamespace ? alternateNamespace : ""}
											aria-label="centered"
											color="error"
										>
											{alternateNamespace}
										</ToggleButton>
									</ToggleButtonGroup>
								</Grid>
							</Grid>
						</div>

						<br />
						<Divider />
					</>
				)}

				{!userTracker && <h1>Likely need to Facebook Login</h1>}
				{!userTracker && (
					<Fragment>
						<br />
						<ConfirmDialog
							buttonText={"Clear Storage"}
							onClick={onClickClearStorage}
						/>
					</Fragment>
				)}
				{userTracker && (
					<>
						<TimeTools />
						<Divider />
						<h1>Device</h1>
						<div>
							<TextField label="Platform" value={platform} disabled />
						</div>
						<br />
						<Divider />
						<h1>User</h1>
						<UserIdBox userId={userTracker.id} />
						<br />
						<div>
							<Grid
								container
								sx={{
									display: "flex",
									flexDirection: "row"
								}}
							>
								<Grid item>
									<TextField
										label="Loyalty Points"
										value={userTracker.loyaltyPoints.toLocaleString("en-US")}
										disabled
									/>
								</Grid>
								<Grid item>
									<SetLoyaltyPointsDialog />
								</Grid>
							</Grid>
						</div>
						<br />
						<div>
							<TextField
								label="Total Loyalty Point Spend"
								value={userTracker.totalLoyaltyPointSpend.toLocaleString(
									"en-US"
								)}
								disabled
							/>
						</div>
						{/* <br />
					<div>
						<TextField
							label="Daily Login Streak"
							value={userTracker.dailyLoginStreak}
							disabled
						/>
					</div> */}
						<br />
						<div>
							<Grid
								container
								sx={{
									display: "flex",
									flexDirection: "row"
								}}
							>
								<Grid item>
									<SetAuthTokenTtlDialog onClick={onClickSetAuthToken} />
								</Grid>
							</Grid>
						</div>
						<br />
						<SegmentationDialog />
						<br />
						<ConfirmDialog
							buttonText={"Clear Inbox Messages"}
							onClick={onClickClearInboxMessages}
						/>
						<br />
						<ConfirmDialog
							buttonText={"Clear First Login"}
							onClick={onClickClearFirstLogin}
						/>
						<br />
						<ConfirmDialog
							buttonText={"Clear User"}
							onClick={onClickClearUser}
						/>
						<br />
						<div>
							<ButtonGroup>
								<Button onClick={onClickOpenAdminTool}>Open Admin Tool</Button>
							</ButtonGroup>
						</div>
						<br />
						<ConfirmDialog
							buttonText={"Clear Storage"}
							onClick={onClickClearStorage}
						/>
						<br />
						<div>
							<ButtonGroup>
								<Button onClick={onClickShowHideDebugLabels}>
									Show / Hide Debug Labels
								</Button>
							</ButtonGroup>
						</div>
						<br />
						<div>
							<ConfirmDialog
								buttonText={"CLEAR ALL USER TRACKERS"}
								onClick={onClearAllTrackers}
							/>
						</div>
						<br />
						<div>
							<ConfirmDialog
								buttonText={"CLEAR PURCHASE TRACKERS"}
								onClick={onClearPurchaseTrackers}
							/>
						</div>
						<br />
						<ClearAppPurchaseData showSuccessDialog={showSuccessDialog} />
						<br />
						<FormControlLabel
							control={
								<Switch
									size="medium"
									checked={adsPersonalization}
									onChange={handleAdsPersonalizationChange}
									inputProps={{ "aria-label": "controlled" }}
								/>
							}
							label="Ads personalization"
						/>
						<br />
						<ResultConfirmationDialog
							title={confirmResultTitle}
							show={confirmResultDialog}
							setConfirmationResultDialog={setConfirmResultDialog}
						/>
						<div>
							<FormControl fullWidth>
								<InputLabel>Metadata</InputLabel>
								<Select
									value={metadata}
									label="Metadata"
									onChange={handleMetadataSelect}
								>
									{userTracker?.metadata &&
										Object.keys(userTracker.metadata).map((md) => (
											<MenuItem key={md} value={md}>
												{md}
											</MenuItem>
										))}
								</Select>
							</FormControl>
							<ConfirmDialog
								disabled={metadata === ""}
								buttonText={"CLEAR METADATA"}
								onClick={onClearMetadata}
							/>
						</div>
						<br />
						<Divider />
					</>
				)}

				{userTracker && (
					<>
						<h1>A/B Testing</h1>
						<div>
							<ButtonGroup>
								<ConfirmDialog
									buttonText={"clear experiments"}
									onClick={onClearABExperiments}
								/>
							</ButtonGroup>
						</div>
						<br />
						<ExperimentsDialog />
						<br />
						{abData?.experiments && (
							<Accordion>
								<AccordionSummary expandIcon={<ExpandMoreIcon />}>
									Current A/B Experiments
								</AccordionSummary>
								<AccordionDetails>
									<div
										style={{
											//marginTop: "1rem",
											width: "100%",
											fontSize: 11,
											whiteSpace: "pre",
											//border: "1px solid black",
											borderRadius: "5px"
										}}
									>
										{JSON.stringify(abData.experiments, null, 2)}
									</div>
								</AccordionDetails>
							</Accordion>
						)}
						<br />
						<Divider />
					</>
				)}

				{userTracker && (
					<>
						{userTracker && isFeatureFlagEnabled(FeaturesFlags.DAILY_BONUS) && (
							<>
								<h1>Daily Login Streak</h1>
								<div>
									<ButtonGroup>
										<ConfirmDialog
											buttonText={"clear tracker"}
											onClick={onClearDailyLoginStreakTracker}
										/>
									</ButtonGroup>
								</div>
								<br />
								<div>
									<Grid
										container
										sx={{
											display: "flex",
											flexDirection: "row"
										}}
									>
										<Grid item>
											<TextField label="Collect Series" value={0} disabled />
										</Grid>
										<Grid item>
											<SetDailyLoginSeriesDialog />
										</Grid>
									</Grid>
								</div>
								<br />
								<Divider />
							</>
						)}
						<>
							<h1>Club Free Gift</h1>
							<ClubFreeGiftTools showSuccessDialog={showSuccessDialog} />
							<br />
							<Divider />
						</>

						<PoisBountyTools />

						{userTracker && (
							<>
								<h1>Club Gifts Galore v2</h1>
								<div>
									<ButtonGroup>
										<ConfirmDialog
											buttonText={"clear tracker"}
											onClick={onClearGiftsGaloreV2Tracker}
										/>
									</ButtonGroup>
								</div>
								<br />
								<div>
									<FormControl fullWidth>
										<InputLabel>tuid</InputLabel>
										<Select value={tuid} label="tuid" onChange={handleTuid}>
											<MenuItem value={userTracker.id}>My tuid</MenuItem>
											{cggv2?.tracker?.tiers?.[
												cggv2.tracker.activeTierIndex
											]?.qualifiedMemberUserIds
												.filter((id) => id !== userTracker.id)
												.map((uid) => {
													return (
														<MenuItem key={uid} value={uid}>
															{uid}
														</MenuItem>
													);
												})}
										</Select>
									</FormControl>
									<ButtonGroup>
										<ConfirmDialog
											buttonText={"simulate purchase"}
											onClick={onSimulatePurchaseGiftsGalore}
										/>
									</ButtonGroup>
								</div>
								<br />
								<div>
									<SetClubGiftsGalorePurchaseDialog version="v2" />
								</div>
								<br />
								<Divider />
							</>
						)}
						<>
							<h1>Trigger CGG Popup</h1>
							<div>
								<FormControl fullWidth>
									<InputLabel>Popup</InputLabel>
									<Select
										value={popup}
										label="Popups"
										onChange={handlePopupTrigger}
									>
										<MenuItem value={"cgg-new-tier"}>New Tier</MenuItem>
										<MenuItem value={"cgg-not-enough-club-members"}>
											Not enough club members
										</MenuItem>
										<MenuItem value={"cgg-event-completed"}>
											Event completed
										</MenuItem>
										<MenuItem value={"cgg-purchase-success"}>
											Purchase success
										</MenuItem>
										<MenuItem value={"cgg-more-info"}>FTUE (v1-v2)</MenuItem>
										<MenuItem value={"cgg-earned-reward"}>
											Earned reward v1
										</MenuItem>
									</Select>
								</FormControl>
								<ButtonGroup sx={{ mt: 0.5 }}>
									<Button
										disabled={popup === ""}
										onClick={() => popup && dispatch(onOpenPopUp(popup))}
									>
										Trigger Popup
									</Button>
								</ButtonGroup>
							</div>
							<br />
						</>

						{/* {userTracker && (
						<>
							<h1>Club Gifts Galore</h1>
							<div>
								<ButtonGroup>
									<ConfirmDialog
										buttonText={"clear tracker"}
										onClick={onClearGiftsGaloreTracker}
									/>
								</ButtonGroup>
							</div>
							<br />
							<div>
								<ButtonGroup>
									<ConfirmDialog
										buttonText={"clear view count"}
										onClick={onClearGiftsGaloreViewCount}
									/>
								</ButtonGroup>
							</div>
							<br />
							<div>
								<ButtonGroup>
									<ConfirmDialog
										buttonText={"clear has seen reward"}
										onClick={onClearGiftsGaloreSeenReward}
									/>
								</ButtonGroup>
							</div>
							<div>
								<Grid
									container
									sx={{
										marginTop: "1rem",
										display: "flex",
										flexDirection: "row"
									}}
								>
									<Grid item>
										<TextField label="Purchases" value={1} disabled />
									</Grid>
									<Grid item>
										<SetClubGiftsGalorePurchaseDialog version="v1" />
									</Grid>
								</Grid>
							</div>
							<br />
							<Divider />
						</>
					)} */}

						{userTracker && isFeatureFlagEnabled(FeaturesFlags.DRIP_OFFER) && (
							<>
								<h1>Drip Offer</h1>
								<div>
									<ButtonGroup>
										<ConfirmDialog
											buttonText={"clear tracker"}
											onClick={onClearDripOfferTracker}
										/>
									</ButtonGroup>
								</div>
								<div>
									<GetLocalTimeZones />
								</div>
								<br />
								<Divider />
							</>
						)}

						{userTracker && (
							<>
								<h1>Endless Offers</h1>
								<div>
									<ButtonGroup>
										<ConfirmDialog
											buttonText={"clear tracker"}
											onClick={onClearEndlessOffersTracker}
										/>
									</ButtonGroup>
								</div>
								<br />
								<div>
									<Grid
										container
										sx={{
											display: "flex",
											flexDirection: "row"
										}}
									>
										<Grid item>
											<TextField label="Purchases" value={1} disabled />
										</Grid>
										<Grid item>
											<SetEndlessOfferPurchaseDialog />
										</Grid>
									</Grid>
								</div>
								<br />
								<Divider />
							</>
						)}

						<>
							<h1>Waterfall</h1>
							<div>
								<ButtonGroup>
									<ConfirmDialog
										buttonText={"clear current tracker"}
										onClick={onClearWaterfallTracker}
									/>
								</ButtonGroup>
							</div>
							<br />
							<div>
								<ButtonGroup>
									<ConfirmDialog
										buttonText={"clear all trackers"}
										onClick={onClearWaterfallTrackers}
									/>
								</ButtonGroup>
							</div>
							<br />
							<Divider />
						</>
						<>
							<h1>Rebate Offer</h1>
							<RebateOfferTools />
							<br />
							<Divider />
						</>
						<>
							<h1>PWA</h1>
							<PWATools />
							<br />
							<Divider />
						</>
						<>
							<h1>Payment Mode</h1>
							<br />
							<div>
								<Grid container>
									<Grid item>
										<ToggleButtonGroup
											exclusive
											onChange={handleDryRunToggle}
											aria-label="text alignment"
										>
											<ToggleButton
												value=""
												aria-label="left aligned"
												color="success"
											>
												Default
											</ToggleButton>
											<ToggleButton
												value="true"
												aria-label="centered"
												color="error"
											>
												Test
											</ToggleButton>
											<ToggleButton
												value="false"
												aria-label="centered"
												color="error"
											>
												Real
											</ToggleButton>
										</ToggleButtonGroup>
									</Grid>
								</Grid>
							</div>

							<br />
							<Divider />
						</>
						<>
							<h1>DIPs</h1>
							<div>
								<ButtonGroup>
									<ConfirmDialog
										buttonText={"clear user actions"}
										onClick={onClearUserDipActions}
									/>
								</ButtonGroup>
							</div>
							<br />
							<div>
								<ButtonGroup>
									<ConfirmDialog
										buttonText={"clear user requisitions"}
										onClick={onClearUserDipRequisitions}
									/>
								</ButtonGroup>
							</div>
							<br />
							<div>
								<ButtonGroup>
									<ConfirmDialog
										buttonText={"clear sticky dips"}
										onClick={onClearUserStickyDip}
									/>
								</ButtonGroup>
							</div>
							<br />
							<div>
								<FormControl fullWidth>
									<InputLabel>Sticky DIP</InputLabel>
									<Select
										value={dip}
										label="Sticky DIPs"
										onChange={handleDipSelect}
									>
										{Object.values(stickyDIPsDisplayed).map((sd) => (
											<MenuItem key={sd?.[0]?.id} value={sd?.[0]?.dip?.id}>
												{sd?.[0]?.campaignGroup}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</div>
							<div>
								<ButtonGroup>
									<ConfirmDialog
										disabled={dip === ""}
										buttonText={"clear specific sticky dip"}
										onClick={onClearSpecificStickyDip}
									/>
								</ButtonGroup>
							</div>
							<br />
							<div>
								<ButtonGroup>
									<ConfirmDialog
										buttonText={"clear all"}
										onClick={onClearAll}
									/>
								</ButtonGroup>
							</div>
							<br />
							<div>
								<ButtonGroup>
									<Button
										variant="outlined"
										onClick={() => dispatch(getAllDIPs())}
									>
										LOAD ALL DIPS
									</Button>
								</ButtonGroup>
								{dips && (
									<Accordion sx={{ mt: 2 }}>
										<AccordionSummary expandIcon={<ExpandMoreIcon />}>
											{!debug.data ? "DIPs" : "ALL DIPs"}
										</AccordionSummary>
										<AccordionDetails>
											<ul style={{ padding: "0 1rem", marginTop: 0 }}>
												{dips.map(({ dip, isUserMatch }, key) => (
													<li key={key} style={{ marginBottom: "4px" }}>
														<div
															style={{
																alignItems: "center",
																display: "grid",
																gridTemplateColumns: "120px 80px",
																gridGap: "10px",
																backgroundColor: isUserMatch
																	? "yellow"
																	: "transparent"
															}}
														>
															<span
																style={{
																	wordBreak: "break-all",
																	fontSize: "13px"
																}}
																title={dip.id}
															>
																{dip.id}: {dip.triggerType}
															</span>
															<Button
																onClick={() =>
																	dispatch(
																		onDIPtrigger({
																			triggerType: dip.triggerType
																		})
																	)
																}
																variant="outlined"
															>
																OPEN
															</Button>
														</div>
													</li>
												))}
											</ul>
										</AccordionDetails>
									</Accordion>
								)}
							</div>
							<br />
							<Divider />
						</>
						<>
							<h1>Popups</h1>
							<PopupTools />
							<Divider />
						</>
						<>
							<h1>Segmentation</h1>
							{debug.userSegment ? (
								<Accordion sx={{ mt: 1 }}>
									<AccordionSummary expandIcon={<ExpandMoreIcon />}>
										Current User Segmentation Data
									</AccordionSummary>
									<AccordionDetails>
										<div
											style={{
												//marginTop: "1rem",
												width: "100%",
												fontSize: 11,
												whiteSpace: "pre",
												//border: "1px solid black",
												borderRadius: "5px"
											}}
										>
											{debug?.userSegment
												? JSON.stringify(debug?.userSegment, null, 2)
												: ""}
										</div>
									</AccordionDetails>
								</Accordion>
							) : null}
							<Accordion sx={{ mt: 2 }}>
								<AccordionSummary expandIcon={<ExpandMoreIcon />}>
									Segments
								</AccordionSummary>
								<AccordionDetails>
									<div>
										{/* eslint-disable-next-line */}
										{debug.segments.map((item: any) => (
											<div
												key={item.id}
												style={{
													marginBottom: "1rem",
													width: "100%",
													fontSize: 11,
													whiteSpace: "pre",
													border: "1px solid black",
													borderRadius: "5px"
												}}
											>
												{item ? JSON.stringify(item, null, 2) : ""}
											</div>
										))}
									</div>
								</AccordionDetails>
							</Accordion>
							<br />
							<Divider />
						</>
						<>
							<h1>Logs</h1>
							<NetworkLogs
								onFocusChange={(e) => setFilterNetworkFieldFocused(e)}
							/>
							<br />
							<Divider />
						</>
						<br />
						<br />
					</>
				)}
			</MySwipeableDrawer>
		</>
	);
};

export default DebugConsole;
